import { takeLatest, put, call, select } from 'redux-saga/effects';
import { checkToken } from '../auth/sagas';
import { Urls } from '../../config/urls';
import { getTask, patchTask, postTask } from '../../services';
import {
  BankAccountsActionType,
  getBankAccountsSuccess,
  getBankAccountsError,
  getBanksForBankAccountsSuccess,
  getBanksForBankAccountsError,
  addBankAccountSuccess,
  addBankAccountError,
  sendEditBankAccountSuccess,
  sendEditBankAccountError,
} from './actions';
import { PanelStore } from '../interfaces';
import { segmentKycFormL2BankSubmit } from '../../utils/analytics';

function* getBankAccounts() {
  yield* checkToken();
  const state: PanelStore.RootState = yield select();

  const { response, error } = yield call(getTask, {
    url: Urls.api.allBankAccounts,
    token: state.auth.token,
  });

  if (response) {
    yield put(getBankAccountsSuccess(response));
  } else {
    yield put(getBankAccountsError(error));
  }
}

export function* getBankAccountsSaga() {
  yield takeLatest(BankAccountsActionType.GET_BANK_ACCOUNTS, getBankAccounts);
}

function* getBanksForBankAccounts(action: any) {
  yield* checkToken();
  const state: PanelStore.RootState = yield select();

  const { response, error } = yield call(getTask, {
    url: `${Urls.api.banks}?country=${action.country}`,
    token: state.auth.token,
  });

  if (response) {
    yield put(getBanksForBankAccountsSuccess(response));
  } else {
    yield put(getBanksForBankAccountsError(error));
  }
}

export function* getBanksForBankAccountsSaga() {
  yield takeLatest(BankAccountsActionType.GET_BANKS_FOR_BANK_ACCOUNTS, getBanksForBankAccounts);
}

function* addBankAccount(action: any) {
  yield* checkToken();
  const state: PanelStore.RootState = yield select();
  const { response, error } = yield call(postTask, {
    url: Urls.api.addBeneficiary,
    body: {
      ...action.values,
    },
    token: state.auth.token,
  });

  if (response) {
    if (action.isStep2) {
      segmentKycFormL2BankSubmit();
    }
    yield put(addBankAccountSuccess(response));
  } else {
    yield put(addBankAccountError(error));
    if (action.isStep2) {
      segmentKycFormL2BankSubmit({
        error
      });
    }
  }
}

export function* addBankAccountSaga() {
  yield takeLatest(BankAccountsActionType.ADD_BANK_ACCOUNT, addBankAccount);
}

function* sendEditBankAccount(action: any) {
  yield* checkToken();
  const state: PanelStore.RootState = yield select();

  const { id, values } = action;
  const { response, error } = yield call(patchTask, {
    url: Urls.api.editBankAccount,
    body: {
      id,
      ...values,
    },
    token: state.auth.token,
  });

  if (response) {
    yield put(sendEditBankAccountSuccess(response));
  } else {
    yield put(sendEditBankAccountError(error));
  }
}

export function* sendEditBankAccountSaga() {
  yield takeLatest(BankAccountsActionType.EDIT_BANK_ACCOUNT, sendEditBankAccount);
}
